import type { WebinarModule } from 'api/microlearning/types'

export const getWebinarTopicData = (
  originalTopicData: { topikTitle?: string; topikId?: number },
  topicIds: number[],
  webinarModules: WebinarModule[]
): { topikTitle?: string; topikId?: number } | null => {
  if (!!originalTopicData.topikId && !!originalTopicData.topikTitle) {
    return {
      topikTitle: originalTopicData.topikTitle,
      topikId: originalTopicData.topikId,
    }
  }
  const topicData = webinarModules.reduce<
    { topikTitle: string; topikId: number }[]
  >((topicData, module) => {
    if (topicIds.includes(module.topikId)) {
      return [
        ...topicData,
        { topikTitle: module.topikTitle, topikId: module.topikId },
      ]
    }
    return topicData
  }, [])
  /** Return null if user has more than topic title (user is multi-jenjang) */
  if (topicData.length > 1) return null

  const [topicDatum] = topicData
  return topicDatum
}
